import { render } from "./ScreenshotShow.vue?vue&type=template&id=1dba0e44&scoped=true"
import script from "./ScreenshotShow.vue?vue&type=script&lang=js"
export * from "./ScreenshotShow.vue?vue&type=script&lang=js"

import "./ScreenshotShow.vue?vue&type=style&index=0&id=1dba0e44&lang=scss"
import "./ScreenshotShow.vue?vue&type=style&index=1&id=1dba0e44&scoped=true&lang=scss"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dba0e44"]])

export default __exports__